import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { ClientFormInput, SimpleSelectData } from 'src/types';
import { EStoreAgencyInfo, EStoreAgencyState, EStoreClientRequestForm, EStoreSubmitDataState } from '../EStore.types';

export const eStoreAgencyExistSelector = (state: RootState): boolean => {
  return !!state.eStore.agency.info;
};

export const eStoreAgencyState = (state: RootState): EStoreAgencyState => {
  return state.eStore.agency;
};

export const eStoreAgencyInfoSelector = (state: RootState): EStoreAgencyInfo | null => {
  return state.eStore.agency.info;
};

export const eStoreFormSenderSelector = (state: RootState): ClientFormInput => {
  return state.eStore.form.sender;
};

export const eStoreFormReceiverSelector = (state: RootState): ClientFormInput | null => {
  return state.eStore.form.receiver;
};

export const eStoreFormToAgencySelector = (state: RootState): string => {
  return state.eStore.form.toAgency;
};

export const esStoreAgencyNameSelector = createSelector(
  eStoreAgencyInfoSelector,
  (info: EStoreAgencyInfo | null): string => {
    return info?.name ?? '';
  },
);

export const eStoreAgenciesSelector = (state: RootState): EStoreAgencyInfo[] => {
  return state.eStore.agency.agencies;
};

export const eStoreSenderIsNotReceiverSelector = (state: RootState): boolean => {
  return state.eStore.form.senderIsNotReceiver;
};

export const eStoreFormStateSelector = (state: RootState): EStoreClientRequestForm => {
  return state.eStore.form;
};

export const eStoreSubmitDataIsLoadingSelector = (state: RootState): boolean => {
  return state.eStore.submitData.isLoading;
};

export const eStoreSubmitDataErrorSelector = (state: RootState): Error | null => {
  return state.eStore.submitData.error;
};

export const eStoreSubmitDataSuccessSelector = (state: RootState): string | null => {
  return state.eStore.submitData.success;
};

export const eStoreSubmitDataStateSelector = (state: RootState): EStoreSubmitDataState => {
  return state.eStore.submitData;
};

export const eStoreAgenciesForSelectSelector = createSelector(eStoreAgenciesSelector, (agencies): SimpleSelectData => {
  return agencies.map((agency) => ({ label: agency.name, value: agency.slug }));
});
